function notifyCart(e) {
    if (window.allow_direct_cart) {
        var t = $("#umbrella"),
            n = t.offset().top,
            r = t.offset().left,
            i = $(e);
        $("body").append(i);
        $(i).hide();
        $(i).fadeIn("slow", "easeInOutExpo", function() {
            var e = $(this).offset().top,
                t = $(this).offset().left;
            $(this).css({
                margin: 0,
                left: t,
                top: e,
                position: "absolute"
            }).delay(2e3).animate({
                top: 0,
                left: "auto",
                right: 0,
                opacity: 1
            }, 3e3, "easeInOutExpo", function() {
                $(this).remove();
                $(".product .product-wait").hide();
                window.location = "/cart"
            })
        })
    } else {
        $("#cart-loading").removeClass("hide");
        $(".product .product-wait").hide();
        $(".cart-sidebar").toggleClass("opened");
        $("html,body").toggleClass("cart-opened")
    }
}

function addToCart(e) {
    if (typeof e !== "undefined") e.preventDefault();
    $("#umbrella .cart-loading").removeClass("hide");
    var t = $(this);
    t.parents(".product").find(".product-wait").show();
    var n = t.parents("form");
    if (n.serialize().length == 0) {
        var r = t.parents(".product-information");
        n = r.find("form.product-actions")
    }
    $.ajax({
        type: "POST",
        url: "/cart/add.js",
        async: true,
        data: n.serialize(),
        dataType: "json",
        error: addToCartFail,
        success: addToCartSuccess,
        cache: false
    });
    $(".modal").modal("hide")
}

function addToCartSuccess(e, t, n) {
    $.ajax({
        type: "GET",
        url: "/cart.js",
        async: true,
        cache: false,
        dataType: "json"
    });
    var r = '<div class="popupaddcart">Item added to Cart!</div>';
    notifyCart(r);
    Shopify.getCart(function(e) {
        Shopify.updateCartInfo(e, "cart-info")
    })
}

function addToCartFail(e, t, n) {
    var r = $.parseJSON(e.responseText);
    var i = '<div class="popupaddcart">' + r.description + "</div>";
    notifyCart(i);
    $("#umbrella .cart-loading").addClass("hide")
}

function searchPlaceholder() {
    if (!Modernizr.input.placeholder) {
        $("#top-search-input").focus(function() {
            var e = $(this);
            if (e.val() == e.attr("placeholder")) {
                e.val("");
                e.removeClass("placeholder")
            }
        }).blur(function() {
            var e = $(this);
            if (e.val() == "" || e.val() == e.attr("placeholder")) {
                e.addClass("placeholder");
                e.val(e.attr("placeholder"))
            }
        }).blur();
        $("[placeholder]").parents("form").submit(function() {
            $(this).find("[placeholder]").each(function() {
                var e = $(this);
                if (e.val() == e.attr("placeholder")) {
                    e.val("")
                }
            })
        })
    }
}(function(e) {
    function t() {}
    for (var n = "assert,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,timeStamp,profile,profileEnd,time,timeEnd,trace,warn".split(","), r; r = n.pop();) {
        e[r] = e[r] || t
    }
})(function() {
    try {
        console.log();
        return window.console
    } catch (e) {
        return window.console = {}
    }
}());
var GLOBAL = {
    common: {
        init: function() {
            $("html").removeClass("no-js").addClass("js");
            searchPlaceholder();
            $(".add-to-cart").bind("click", addToCart)
        }
    },
    templateIndex: {
        init: function() {}
    },
    templateProduct: {
        init: function() {}
    },
    templateCart: {
        init: function() {}
    }
};
var UTIL = {
    fire: function(e, t, n) {
        var r = GLOBAL;
        t = t === undefined ? "init" : t;
        if (e !== "" && r[e] && typeof r[e][t] == "function") {
            r[e][t](n)
        }
    },
    loadEvents: function() {
        var e = document.body.id;
        UTIL.fire("common");
        $.each(document.body.className.split(/\s+/), function(t, n) {
            UTIL.fire(n);
            UTIL.fire(n, e)
        })
    }
};
$(document).ready(UTIL.loadEvents)